export default () => import(/* webpackChunkName: 'coffee/activities/discount-zone' */ './DiscountZone');
